import { render, staticRenderFns } from "./AgreementsCarrier.vue?vue&type=template&id=674e9cb6&"
import script from "./AgreementsCarrier.vue?vue&type=script&lang=js&"
export * from "./AgreementsCarrier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports